import types from '../actions/types';

import {paginatedResultReducer, initialState} from './common/paginated_results';
import {singleResultReducer, singleResultInitialState} from './common/single-result';
import {multipleResultReducer, multipleResultInitialState} from './common/multiple-results';

const initial_state = {
    seasons: initialState,
    season: singleResultInitialState,
    availableSeasons: multipleResultInitialState
}

export default function(state = initial_state, action) {
    switch (action.type) {
        default:
            return {
                ...state,
                season: singleResultReducer(state.season, types.ADMIN_LOAD_SEASON, action),
                seasons: paginatedResultReducer(state.seasons, types.ADMIN_LOAD_SEASONS, action),
                availableSeasons: multipleResultReducer(state.availableSeasons, types.LOAD_SEASONS, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/season.js